/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import 'moment/min/locales';
import cx from 'classnames';
import { OSMMap } from 'volto-venue';
import { Grid, Container } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const messages = defineMessages({
  default_detail_link: {
    id: 'Vedi',
    defaultMessage: 'Vedi',
  },
  no_markers: {
    id: 'Non ci sono punti da mostrare sulla mappa',
    defaultMessage: 'Non ci sono punti da mostrare sulla mappa',
  },
});

const MapTemplate = ({
  items,
  isEditMode,
  linkTitle,
  linkHref,
  title,
  show_map_full_width,
  show_block_bg,
  color_title,
  image_bg,
  map_size = 'medium',
}) => {
  const intl = useIntl();
  let history = useHistory();
  moment.locale(intl.locale);

  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    let points = items
      .filter(
        (item) =>
          item.geolocation &&
          item.geolocation?.latitude &&
          item.geolocation?.latitude !== 0 &&
          item.geolocation?.longitude &&
          item.geolocation?.longitude !== 0,
      )
      .map((item) => {
        return {
          title: item.title,
          latitude: item.geolocation.latitude,
          longitude: item.geolocation.longitude,

          onMarkerClick: (e) => {
            history.push(item['@id']);
          },
        };
      });

    setMarkers(points);
  }, [items]);

  const linkMore = linkHref?.[0]?.['@id'];

  // Background image
  const imageBgSize = 'leadimage';
  const imageObj = image_bg?.[0];
  const image = imageObj
    ? imageObj.image?.scales?.[imageBgSize]?.download ||
      imageObj['@id'] + '/@@images/image/' + imageBgSize
    : null;
  const imageUrl = image ? flattenToAppURL(image) : null;

  const content = (
    <Container>
      {title && (
        <div className="map-title">
          <h2>{title}</h2>
        </div>
      )}
      {items?.length > 0 && markers?.length > 0 ? (
        <Grid
          className={cx('map-wrapper', {
            'full-width': show_map_full_width,
            ['size_' + map_size]: map_size,
          })}
        >
          <OSMMap markers={markers} showTooltip />
        </Grid>
      ) : (
        <p className="text-no-markers">
          {intl.formatMessage(messages.no_markers)}
        </p>
      )}

      {linkMore && (
        <div className="link-more">
          <UniversalLink
            href={flattenToAppURL(linkMore)}
            className="ui button primary"
          >
            {linkTitle || intl.formatMessage(messages.default_detail_link)}
          </UniversalLink>
        </div>
      )}
    </Container>
  );

  return (
    <div
      className={cx('map-template', {
        'text-black': color_title === 'black',
        'text-white': color_title === 'white',
      })}
    >
      {show_block_bg ? (
        <>
          {imageUrl ? (
            <div
              className="full-width block-bg bg-image"
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            >
              {content}
            </div>
          ) : (
            <div className="full-width block-bg">{content}</div>
          )}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  );
};

MapTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
};

export default MapTemplate;
